/* eslint-disable dot-notation */
import axios from 'axios';
import { CASH_COUNTER_API_URL, attachAuthInterceptor, attachRefreshInterceptor, baseHeaders, mobileHeaders, REQUEST_TIME_OUT } from './Utils';

const headers = { ...baseHeaders, ...mobileHeaders };
const instance = axios.create({
  baseURL: CASH_COUNTER_API_URL,
  timeout: REQUEST_TIME_OUT,
  headers,
});

/**
 * Request interceptor to add authentication token to all requests
 * Retrieves the stored access token from storage and attaches it as a Bearer token
 */
attachAuthInterceptor(instance);
/**
 * Response interceptor to handle token refresh on 401 Unauthorized responses
 * Attempts to refresh the access token using the refresh token
 * Retries the original request with the new token on success
 * Redirects to login on refresh failure
 */
// Handle expired access tokens
attachRefreshInterceptor(instance);

/**
 * Performs a POST request to the specified URL
 * @param {string} url - The endpoint URL (relative to CASH_COUNTER_API_URL)
 * @param {Object} data - The request payload
 * @returns {Promise} Axios promise with response data
 */
export const doPost = (url, data, config) => {
  console.log(data);
  return instance.post(url, data, config);
};

/**
 * Performs a PUT request to the specified URL
 * @param {string} url - The endpoint URL (relative to CASH_COUNTER_API_URL)
 * @param {Object} data - The request payload
 * @returns {Promise} Axios promise with response data
 */
export const doPut = (url, data) => {
  console.log(data);
  return instance.put(url, data);
};

/**
 * Performs a PATCH request to the specified URL
 * @param {string} url - The endpoint URL (relative to CASH_COUNTER_API_URL)
 * @param {Object} data - The request payload
 * @returns {Promise} Axios promise with response data
 */
export const doPatch = (url, data) => {
  console.log(data);
  return instance.patch(url, data);
};

/**
 * Performs a GET request to the specified URL
 * @param {string} url - The endpoint URL (relative to CASH_COUNTER_API_URL)
 * @param {Object} [params] - Optional query parameters
 * @returns {Promise} Axios promise with response data
 */
export const doGet = (url, params) => {
  console.log(params);
  return instance.get(url, {
    params: params ? params : null,
  });
};

/**
 * Performs a DELETE request to the specified URL
 * @param {string} url - The endpoint URL (relative to CASH_COUNTER_API_URL)
 * @param {Object} [params] - Optional query parameters
 * @returns {Promise} Axios promise with response data
 */
export const doDelete = (url, params) => {
  console.log(params);
  return instance.delete(url, {
    params: params ? params : null,
  });
};
